import { Pipe, PipeTransform } from '@angular/core';
import { ProductService } from '@modules/bcm/products/product/product.service';
import { getTaxRateValue } from '@core/functions/get-tax-rate-value';
import { InvoicePosition } from '@shared/models/invoice-position';

@Pipe({
    name: 'bcmNetToGrossPrice',
    standalone: false
})
export class NetToGrossPricePipe implements PipeTransform {

    constructor(private productService: ProductService) {
    }

    transform(netPrice: number, position: InvoicePosition): number {
        if (!netPrice) {
            return 0;
        }
        const taxRateValue = getTaxRateValue(position);
        return this.productService.getGrossPrice(netPrice, taxRateValue);
    }
}
